import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[vbPersonName]',
})
export class PersonNameDirective {
    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(): void {
        const inputElement: HTMLInputElement = this.el
            .nativeElement as HTMLInputElement;
        const value: string = inputElement.value;
        // Allow only alphabets and spaces
        const sanitizedValue: string = value.replace(/[^a-zA-Z\s]/g, '');
        inputElement.value = sanitizedValue;
    }
}
